export const useEnableRedeemInRestaurantForUnauthenticatedExperiment = () => false;
